import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../accelerator-area.service';
import { AccDeliveryService } from '../../acc-delivery.service';
import { getSetup } from './grid/get-setup';


export interface FinalPresentation {
	accVentureId: number,
	ventureName: string,
	entrepreneurs: string,
	finalEventId: number | undefined,
	startUTC: number | undefined,
	roadmapScore: number | undefined,
	deckSubmittedUTC: number | undefined,
	trimesterFinalDeckDueUTC: number | undefined,
	finalPresentationScore: number | undefined,
	updatedUTC: number,
}

@Component({
	selector: 'acc-final-presentation-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './final-presentation-view.part.html',
})
export class AccFinalPresentationViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AccDeliveryService);
	private readonly areaService = inject(AcceleratorAreaService);
	private readonly dialogService = inject(DialogService);
	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});


	public data = computed<FinalPresentation[]>(() => {
		const accVentures = this.areaService.data()?.ventures;
		const events = this.areaService.data()?.events;
		const entrepreneurs = this.areaService.data()?.entrepreneurs;
		const acc = this.areaService.data()?.acc;
		return accVentures?.filter(v => v.status != 'Dropped Out' && v.status != 'Never Started').map(v => {
			return {
				accVentureId: v.accVentureId,
				ventureName: v.ventureName,
				finalEventId: v.finalEventId,
				trimesterFinalDeckDueUTC: acc?.finalDeckDueUTC,
				entrepreneurs: entrepreneurs?.filter(e => e.accVentureId == v.accVentureId).map(e => e.fullName).join(', ') || '',
				startUTC: v.finalEventId ? events?.find(event => event.eventId == v.finalEventId!)?.startUTC || undefined : undefined,
				roadmapScore: v.roadmapScore,
				deckSubmittedUTC: v.deckSubmittedUTC,
				finalPresentationScore: v.finalPresentationScore,
				updatedUTC: v.updatedUTC,
			}
		}) || [];
	});

}